/**
 * Navigatie-items van de app-shell (US-002, US-030).
 *
 * De schermen Bronconfigurator, Import en Instellingen zijn alleen voor beheerders. Een
 * prijsanalist ziet ze niet in de navigatie én kan ze niet via de URL openen; de route toont dan
 * de "Geen toegang"-kaart.
 */

import type { Role } from '@prijsmonitor/shared';

export interface NavItem {
  path: string;
  label: string;
  /** Titel in de topbar. */
  title: string;
  adminOnly: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { path: '/prijsoverzicht', label: 'Prijsoverzicht', title: 'Prijsoverzicht', adminOnly: false },
  // Staat vóór de historie: de grafiek is de vraag "loopt er iets uit elkaar", de tabel het
  // antwoord op "welke prijs precies, op welke dag". Zo is dat ook de leesrichting.
  { path: '/prijsgrafiek', label: 'Prijsgrafiek', title: 'Prijsgrafiek', adminOnly: false },
  { path: '/prijshistorie', label: 'Prijshistorie', title: 'Prijshistorie', adminOnly: false },
  { path: '/producten', label: 'Producten', title: 'Producten & monitoring', adminOnly: true },
  {
    path: '/bronconfigurator',
    label: 'Bronconfigurator',
    title: 'Bronconfigurator',
    adminOnly: true,
  },
  { path: '/import', label: 'Import', title: 'Import', adminOnly: true },
  { path: '/taken', label: 'Taken & logboek', title: 'Taken & logboek', adminOnly: false },
  // Kosten en tarieven zijn bedrijfsgevoelige configuratiegegevens; een prijsanalist hoort die
  // niet te zien (US-041, laatste criterium).
  { path: '/ai-verbruik', label: 'AI-verbruik', title: 'AI-verbruik & kosten', adminOnly: true },
  { path: '/instellingen', label: 'Instellingen', title: 'Instellingen', adminOnly: true },
];

export function visibleNavItems(role: Role | null): NavItem[] {
  return NAV_ITEMS.filter((item) => !item.adminOnly || role === 'ADMIN');
}

/** Titel in de topbar voor paden die geen eigen navigatie-item hebben. */
export function titleForPath(pathname: string): string | undefined {
  if (pathname.startsWith('/product/')) return 'Productdetail';
  if (pathname === '/versies') return 'Versiegeschiedenis';
  return navItemForPath(pathname)?.title;
}

/** Zoekt het navigatie-item dat bij een pad hoort; ook subpaden zoals /product/:id tellen mee. */
export function navItemForPath(pathname: string): NavItem | undefined {
  // Het productdetail hangt onder het prijsoverzicht; zo blijft dat item actief en klopt de
  // titel in de topbar.
  if (pathname.startsWith('/product/')) {
    return NAV_ITEMS.find((item) => item.path === '/prijsoverzicht');
  }
  return NAV_ITEMS.find((item) => pathname === item.path || pathname.startsWith(`${item.path}/`));
}
